import React from 'react';
import type { XAxisProps } from 'react-native-svg-charts';

export type { XAxisProps };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const XAxis = <T,>(_: XAxisProps<T>) => {
  return <></>;
};
